module.exports = __webpack_public_path__ + "img/原材料订单管理.f3a69cea.png";